export default __webpack_public_path__ + "static/media/withdrawal-peso-icon.947a6506.png";